import { getTransform } from "./qaConfig"

const getSettings_CRUD_Config = {
  ...getTransform("dk_paymentgateway_config_heading_label"),
  ...getTransform("dk_paymentgateway_alert_warning_label"),
  ...getTransform("dk_paymentgateway_create_button"),
  ...getTransform("dk_paymentgateway_save_button"),
  ...getTransform("dk_paymentgateway_cancel_button"),
  ...getTransform("dk_paymentgateway_create_button")
  
}

const doSettingsAddOnTestId = (testIdValue = "null") => {
    let testId = {}
    if (testIdValue) {
      testId["data-testid"] = `dk-paymentgateway-config-${testIdValue}`
    }
  
    return testId
}


export { getSettings_CRUD_Config, doSettingsAddOnTestId }
